export { FullScreenComponent } from './full-screen.component';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/full-screen/index.ts